var React = require('react');

function Book (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.5 2.7V21.3C21.5 22.785 20.3187 24 18.875 24H3.125C1.68125 24 0.5 22.785 0.5 21.3V2.7C0.5 1.215 1.68125 0 3.125 0H3.51094V8.10582C3.51094 8.69299 4.15515 9.05243 4.65483 8.74406L6.3983 7.66808C6.63975 7.51907 6.94462 7.51907 7.18608 7.66808L8.92955 8.74406C9.42923 9.05243 10.0734 8.69299 10.0734 8.10582V0H18.875C20.3187 0 21.5 1.215 21.5 2.7ZM18.5 1.5H17V22.5H18.5C19.3284 22.5 20 21.8284 20 21V3C20 2.17157 19.3284 1.5 18.5 1.5Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"0.5","y1":"0","x2":"22.3133","y2":"0.763465","gradientUnits":"userSpaceOnUse"},React.createElement("stop",{"stopColor":"#6366F1"})))]);
}

Book.defaultProps = {"width":"22","height":"24","viewBox":"0 0 22 24","fill":"none"};

module.exports = Book;

Book.default = Book;
